import React from "react"

import { InstallationReference } from "shared/types/InstallationReference"
import { ImageOverlayPayload } from "shared/ui/image-overlay/ImageOverlay"

import { InstallationReferenceFilterState } from "entities/building-references/types/InstallationReferenceFilterState"
import { ProductSelectOption } from "entities/products/types/ProductSelectOption"

import { InstallationReferenceSelectionView } from "./InstallationReferenceSelectionView"
import { useInstallationReferenceSelectionViewModel } from "./model/useInstallationReferenceSelectionViewModel"

export interface InstallationReferenceSelectionModel {
  installationReferences: InstallationReference[] | undefined
  defaultFilters?: InstallationReferenceFilterState
  availableProductFilterOptions?: ProductSelectOption[]
  defaultSelectedInstallationReferenceIDs?: string[]
  formId?: string
  onSubmit: (selectedInstallationReferenceIDs: string[] | null) => void
  onZoomImage: (payload: ImageOverlayPayload) => void
}

export const InstallationReferenceSelection = React.memo(
  (model: InstallationReferenceSelectionModel) => (
    <InstallationReferenceSelectionView
      {...useInstallationReferenceSelectionViewModel(model)}
    />
  )
)
